import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { UsersComponent } from "./users/users.component";
import { GroupsComponent } from "./groups/groups.component";
import { SignupComponent } from "./signup/signup.component";
import { BucketsComponent } from "./buckets/buckets.component";
import { LayoutComponent } from "./layout/layout/layout.component";
import { AuthGuard } from "./auth.guard";
import { AddUserComponent } from "./add-user/add-user.component";
import { S3objectComponent } from "./s3object/s3object.component";
import { ForgotPasswordModalComponent } from "./forgot-password-modal/forgot-password-modal.component";
import { UpdateUserComponent } from "./update-user/update-user.component";
import { LogoutComponent } from "./logout/logout.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { CreateGroupComponent } from "./create-group/create-group.component";
import { ListPolicyComponent } from "./list-policy/list-policy.component";
import { UpdateGroupRolePolicyComponent } from "./update-group-role-policy/update-group-role-policy.component";
import { CreateBucketComponent } from "./create-bucket/create-bucket.component";
import { UploadS3ObjectComponent } from "./upload-s3-object/upload-s3-object.component";
import { GetSignedUrlComponent } from "./get-signed-url/get-signed-url.component";
import { IamComponent } from "./iam/iam.component";
import { CreateIamUserComponent } from "./create-iam-user/create-iam-user.component";
import { NewPasswordChallangeComponent } from "./new-password-challange/new-password-challange.component";
import { ProfileComponent } from "./profile/profile.component";
import { GridBucketComponent } from "./grid-bucket/grid-bucket.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full"
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "signup",
    component: SignupComponent
  },
  {
    path: "forgotPassword",
    component: ForgotPasswordModalComponent
  },
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        component: DashboardComponent,
        pathMatch: "full"
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users",
        component: UsersComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "groups",
        component: GroupsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "createuser",
        component: AddUserComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "buckets",
        component: BucketsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'buckets/show-object',
        component: S3objectComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "update-user",
        component: UpdateUserComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "change-pass",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "create-group",
        component: CreateGroupComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'list-policy',
        component: ListPolicyComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'update-policy',
        component: UpdateGroupRolePolicyComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'create-bucket',
        component: CreateBucketComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'upload-object',
        component: UploadS3ObjectComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'getSignedUrl',
        component: GetSignedUrlComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'iam',
        component: IamComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'createIamUser',
        component: CreateIamUserComponent ,
        canActivate: [AuthGuard]
      },
      {
        path: 'newPasswordChallange',
        component: NewPasswordChallangeComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'user-profile',
        component: ProfileComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "grid-object",
        component: GridBucketComponent,
        canActivate: [AuthGuard]
      }
    ]
  }, 
  {
    path: "logout",
    component: LogoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "**",
    redirectTo: "/login",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
